export type EmbeddingBadgeKind = 'ok' | 'fail' | 'off' | 'unknown' | 'ingesting';

/**
 * Derives UI badge state from persisted embedding fields (project & knowledge documents).
 */
export function getEmbeddingBadgeKind(
  embeddingEnabled: unknown,
  embeddingSucceeded: unknown,
  chunksCreated: unknown,
  ingestionStatus?: unknown
): EmbeddingBadgeKind {
  if (ingestionStatus === 'queued' || ingestionStatus === 'processing') return 'ingesting';
  if (embeddingEnabled === false) return 'off';
  if (embeddingEnabled !== true) {
    if (embeddingEnabled === undefined && embeddingSucceeded === undefined) return 'unknown';
    return 'unknown';
  }
  if (embeddingSucceeded === true && typeof chunksCreated === 'number' && chunksCreated >= 1) {
    return 'ok';
  }
  if (embeddingSucceeded === false) return 'fail';
  if (embeddingSucceeded === true && typeof chunksCreated === 'number' && chunksCreated === 0) return 'fail';
  return 'unknown';
}
